import { post } from '@/utils/request';

// #region ******** 送样检测 ********
// 预览、填充报告（不盖章）
export const reqReportWordFill = params => {
  return post(`/app/office/reqReportWordFill`, params);
};
// 填充审核或批准签名
export const reqReportWordSignFill = params => {
  return post(`/app/office/reqReportWordSignFill`, params);
};
// 填充报告（盖章）
export const reqReportSealWordFill = params => {
  return post(`/app/office/reqReportSealWordFill`, params);
};
// 填充报告（验证签章）
export const getReportSealWord = params => {
  return post(`/app/office/getReportSealWord`, params);
};
// 生成pdf
export const reqReportPdf = params => {
  return post(`/app/office/reqReportPdf`, params);
};
// #endregion **** 送样检测 ********

// test
export const reqTestWord = params => {
  return post(`/app/office/reqTestWord`, params);
};
